import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { useGetImpersonationToken } from '@hooks/user/useGetImpersonationToken';
import { useIsAuth } from '@hooks/user/useIsAuth';

export const ProtectedRoute = ({ children }) => {
  useGetImpersonationToken();
  const isAuth = useIsAuth();

  useEffect(() => {
    if (!isAuth) {
      return;
    }
  }, [isAuth]);

  if (!isAuth) {
    return <Navigate to="/auth" state={{ from: location.pathname + location.search }} />;
  }

  return children;
};
